<template>
  <br />
  <div class="oddRoundElement">
    <p class="textTitalIndentation">尊敬的用户：</p>
    <p class="text2DIndentation">您好！您将加入“心”健康项目。为了确保本项目顺利进行，并保障您的权益，在您同意参加之前，您需要清楚知道以下相关信息：</p>
    <p class="textIndentation"><strong>一、项目方案介绍</strong></p>
    <p class="text2DIndentation">
      “心”健康项目是由中国科学院下属中科软发起，联合友谊医院、首都医科大学附属安贞医院等共同参与，将以医疗体检机构的专业医疗数据为主，智能手机等设备的健康数据为辅，进行心脏早期风险分析，预测心脏健康趋势，并与合作医疗机构协同，提供一整套针对个人心脏健康的“检-评-管”健康服务产品。本产品非医疗产品，不能替代医疗诊断，高风险客户建议到医疗机构进一步确诊。根据国内外专家意见，早期心脏问题极大概率可以通过干预和调理的方式实现风险降低。我们将持续为您的心脏提供综合健康管理和督导服务。
    </p>
    <p class="textIndentation"><strong>二、数据使用和保留</strong></p>
    <p class="text2DIndentation">在您参与项目的过程中，我们会采集下列必需的信息：您填写的个人基本信息、用药记录、症状等，合作医疗组织获取您的检查原始数据，生活、运动等场景数据，以便履行我们的合同义务。</p>
    <p class="textIndentation">(1)、个人基本信息，包括性别、年龄、身高、体重、所在城市、手机号、身份证等个人基本信息。</p>
    <p class="textIndentation">(2)、检查数据，包括血压数据、血脂数据、尿检数据、心电图数据、胸部CT数据等检查数据。</p>
    <p class="textIndentation">(3)、用药记录、症状等信息用于辅助算法校准，改善效果评估等场景应用。</p>
    <p class="textIndentation">(4)、生活、运动等场景数据，帮助我们提供评估和改进心脏健康的方案。</p>
    <p class="text2DIndentation">在获取您的同意后，我们会收集并处理如下信息：</p>
    <p class="textIndentation">(5)、问卷信息：包括心血管疾病史、是否高血压、是否糖尿病以及受教育情况等，用户研究机构探索研究。</p>
    <p class="text2DIndentation">整体过程中所有采集的数据由授权专人负责管理，数据访问有认证鉴权控制，即只有项目组成员拥有访问和使用数据的权限。而后由授权的专业人员完成数据分析和研究结果分析。</p>
    <p class="text2DIndentation">
      为了保证输出结果质量，您需要保证数据的完整和准确，即关键数据项填充完成、评估数据为您1年内的数据（比对值数据除外）。我们提供您手工输入方式，可以对数据进行调整，但是该部分数据不会被优先认可。</p>
    <p class="textIndentation"><strong>三、受益</strong></p>
    <p class="text2DIndentation">为感谢您参加本次“心”健康项目工作，我们将为您提供专业建议，帮助您了解心脏健康情况，识别潜在的心血管风险，呵护您的心脏健康。</p>
    <p class="textIndentation"><strong>四、风险</strong></p>
    <p class="text2DIndentation">
      用户需要知悉，由于心脏健康及患者体质的特殊性、差异性，以及现有健康管理水平条件的限制等，医师或其他健康服务提供者制定的诊疗方案、健康管理方案等可能不会达到用户预期的效果，需要用户积极配含，长期坚持干预、调理、治疗，才能延缓疾病的进展。医师或其他健康服务提供者已经尽力为患者制定合理的方案，致力于扭转或延缓冠心病发病的趋势，但不可能完全避免，需要在患者的配合下，根据患者情况不断调整干预、调理、健康管理方案。心脏健康的干预需要就诊用户谨遵医嘱、健康管理方案，并积极配合。如果用户未完全遵守和配合，则可能导致效果不理想，基至出现心脏健康转变为疾病反、恶化等不良后果。
    </p>
    <p class="textIndentation"><strong>五、自愿参与与退出</strong></p>
    <p class="text2DIndentation">
      项目开展前请您对使用环境和场景等做详细的了解，然后由您自愿决定是否参与本次项目，您有权在项目未提供服务前退出。同时，为了保证工作的持续开展，我们会收取您一定的费用，用于项目的持续投入，包括计算资源的损耗和人工成本。</p>
    <p class="textIndentation"><strong>六、保密责任</strong></p>
    <p class="text2DIndentation">1、项目组声明所涉及参与者的隐私是指：在用户申请本项目时提供的用户的个人身份识别资料，包括用户的姓名、昵称、电邮地址、出生日期、性别、职业、病例、病情、化验检测报告、所在行业等。
    </p>
    <p class="text2DIndentation">
      2、项目组不会将入选者的个人识别信息出租、出售或泄漏给任何人。以下情况除外：用户明确同意让第三方共享资料；只有透露用户的个人资料，才能提供用户所要求的产品和服务；根据法律法规的规定，向司法机关提供；被搜索引擎在搜索结果中显示；其他服务行为有必要提供的情况。
    </p>
    <p class="text2DIndentation">
      本项目所取得的结果与资料，归“心”健康项目的实施者所有并无偿使用，但您的合法权益不会因为本项目而受到侵犯。除非法律需要，您的身份不会被泄露。项目结果将在不泄露您的身份的前提下因科学目的而发表。</p>
    <p class="textIndentation"><strong>七、第三方数据共享</strong></p>
    <p class="text2DIndentation"> 在获得您的授权情况下，我们才会将采集到的数据共享给第三方合作科技公司做心脏健康研究。我们已经与第三方合作科技公司签署合同并保障合作伙伴有义务保护您的个人数据。</p>
    <p class="textIndentation"><strong>八、如何联系我们</strong></p>
    <p class="text2DIndentation">当使用中出现问题时，您可以通过发送电子邮件至zaozhixin2030@126.com反馈给我们。</p>
    <!--van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }"></van-divider>
        <van-row>
              <van-col offset="1" span="9"><van-checkbox v-model="state.Informed.informedFlag">我已经仔细阅读并同意上述内容</van-checkbox></van-col>
        </van-row-->
    <br />
  </div>
  <br />

  <van-button round color="linear-gradient(to right, #f67f34, #d55809)" size="large" @click="changeInformed">返回</van-button>

  <van-overlay :show="showOverlay" @click="showOverlay = false">
    <div class="wrapper" @click.stop>
      <div class="block">
        <van-cell-group inset>
          <van-notice-bar wrapable :scrollable="false" text="您未做机构绑定" left-icon="info-o" />
          <p class="textIndentationoverlay"><van-notice-bar wrapable :scrollable="false" color="#1989fa"
              background="#ffffff" text="目前仅开放体检机构定向邀约客户绑定。您可以向体检机构获取【邀约码】。" /></p>
          <van-button type="warning" block plain hairline to="about">
            返回项目介绍
          </van-button>
        </van-cell-group>
      </div>
    </div>
  </van-overlay>
  <van-overlay :show="showBinging" @click="showBinging = false">
    <div class="wrapper" @click.stop>
      <div class="block">
        <van-cell-group inset>
          <van-notice-bar wrapable :scrollable="false" text="绑定确认中" left-icon="info-o" />
          <p class="textIndentationoverlay"><van-notice-bar wrapable :scrollable="false" color="#1989fa"
              background="#ffffff" text="您提交的绑定需要【3-5个工作日】确认" /></p>
          <van-button type="warning" block plain hairline to="about">
            返回项目介绍
          </van-button>
        </van-cell-group>
      </div>
    </div>
  </van-overlay>
</template>
<script>

import { ref, onMounted, reactive } from 'vue';
import { getCheckBinding, getCheckInformed } from '../../api/permission'
//import { postChangeInformed } from '../../api/register'
import { useRouter } from 'vue-router';
import { postUserLog } from "../../api/userlog";
export default ({
  setup() {
    const showOverlay = ref(false);
    const showBinging = ref(false);
    const router = useRouter();
    const ulog = reactive({
            UserLog: {
                 path: "",
            },
        });
    const state = reactive({
      Informed: {
        informedFlag: '',
      }
    });
    const changeInformed = () => {
      router.back();
    }
    onMounted(() => {
      ulog.UserLog.path = router.currentRoute.value.fullPath;
      console.log("当前页面路径==" + ulog.UserLog.path);
      postUserLog(ulog.UserLog).then(() => {});
      console.log('页面打开')
      state.Informed.informedFlag = false;
      getCheckBinding().then((res1) => {
        console.log(res1.data.code);
        const binding = res1.data.code;
        if (binding == 60001) {
          showOverlay.value = false;
        } else if (binding == 60002) {
          showBinging.value = true;
        } else {
          showOverlay.value = false;
        }
      })
      getCheckInformed().then((res) => {
        console.log(res.data.code);
        const binding = res.data.code;
        if (binding == 70001) {
          state.Informed.informedFlag = true;
        } else if (binding == 70002) {
          state.Informed.informedFlag = false;
        } else {
          state.Informed.informedFlag = false;
        }
      })
    })
    return {
      showOverlay,
      showBinging,
      state,
      changeInformed
    };
  },
})
</script>

<style lang="less" scoped>
.example {
  font-size: 18px;
  display: block;

}

.oddRoundElement {
  border-radius: 12px 12px;
  font-size: 14px;
  margin: 0 20px;
  background: #FFF;
  color: #000;
}

.textTitalIndentation {
  font-size: 14px;
  text-align: left;
  padding-top: 1em;
  padding-right: 1em;
  padding-left: 1em;
}

.textIndentation {
  font-size: 14px;
  text-align: left;
  padding-right: 1em;
  padding-left: 1em;
}

.text2DIndentation {
  font-size: 14px;
  text-align: left;
  text-indent: 2em;
  padding-right: 1em;
  padding-left: 1em;
}

.textIndentationoverlay {
  font-size: 12px;
  text-align: left;
  margin-top: 10px;

}

.spanCheckbox {
  text-align: left;
  margin-top: 10px;

}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 500px;
  height: 400px;
}</style>
